// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tag_component_wrapper__GToJz","tagsWrapper":"Tag_component_tagsWrapper__Z_glY","title":"Tag_component_title__j8gpV","tag":"Tag_component_tag__Ko9gb"};